/** @format */

import { useContext, useEffect, useState, useRef, useCallback } from "react";

import { useLocation, useNavigate, useParams } from "react-router-dom";

import { EventContext } from "../../Contexts/EventContext";
import Loading from "../../Shared/Components/Loading";
import ModalCustom from "../../Shared/Components/ModalCustom";
import Pagination from "../../Shared/Components/Pagination";
import { error, success } from "../../Shared/Components/Toast";
import useApi from "../../Shared/hooks/api/Index";
import { useRole } from "../../Shared/hooks/CustomHooks";
import useQuery from "../../Shared/queryString";
import { getStoredAuthToken } from "../../Shared/utils/authToken";
import {
  countOfRecourd,
  formatSidLabel,
  isStoredMediaPath,
  resolveMediaUrl,
} from "../../Shared/utils/helper";
import Master from "../Layouts/Master";
import queryString from "query-string";
import * as Yup from "yup";
import { Formik } from "formik";

const validationSchema = Yup.object({});

const EventRegister = () => {
  const { can } = useRole();
  const eventContext = useContext(EventContext);
  const navigate = useNavigate();
  const { id } = useParams();
  const team = useQuery.getParam("team");
  const eventId = useQuery.getParam("eventId");
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [formRemoveId, setFormRemoveId] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [issueTracking, setIssueTracking] = useState("");
  const [imageViewModalOpen, setImageViewModalOpen] = useState(false);
  const [imageViewSrc, setImageViewSrc] = useState(false);
  const [documentsModalOpen, setDocumentsModalOpen] = useState(false);
  const [documentsModalUser, setDocumentsModalUser] = useState(null);
  const [idCardLoading, setIdCardLoading] = useState(false);
  const [acceptLoading, setAcceptLoading] = useState(false);
  const [parseParams, setParseParams] = useState({});
  const [filterModal, setFilterModal] = useState(false);

  const [selected, setSelected] = useState([]);
  const selectAllRef = useRef(null);
  const [bulkLoading, setBulkLoading] = useState(false);

  useEffect(() => {
    const params = queryString.parse(search);
    setParseParams(params);
    getUsers();
    setSelected([]);
  }, [search, id]);

  useEffect(() => {
    const visible = eventContext.users?.data ?? [];
    const visibleIds = visible.map((u) => u.id);
    const selectedCountOnPage = selected.filter((i) =>
      visibleIds.includes(i)
    ).length;
    if (!selectAllRef.current) return;
    if (selectedCountOnPage === 0) {
      selectAllRef.current.indeterminate = false;
      selectAllRef.current.checked = false;
    } else if (
      selectedCountOnPage === visibleIds.length &&
      visibleIds.length > 0
    ) {
      selectAllRef.current.indeterminate = false;
      selectAllRef.current.checked = true;
    } else {
      selectAllRef.current.indeterminate = true;
      selectAllRef.current.checked = false;
    }
  }, [selected, eventContext.users]);

  const getUsers = async () => {
    setLoading(true);
    await useApi.get(
      team != null
        ? `/team/${id}/user${eventId ? `?eventId=${eventId}` : ""}`
        : `/event/${id}/register${search}`,
      {},
      (res) => {
        eventContext.users = res.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error("هنگام دریافت اطلاعات خطایی رخ داده است");
      }
    );
  };

  const removeForm = async (eventId) => {
    setRemoveLoading(true);

    await useApi.delete(
      `/event/${eventId}`,
      {},
      (res) => {
        success("رویداد مورد نظر با موفقیت حذف شد");
        setRemoveLoading(false);
        setModalIsOpen(false);
        getUsers();
      },
      (err) => {
        setRemoveLoading(false);
        setLoading(false);
        error("حذف به علت خطا انجام نشد");
      }
    );
  };

  const educations = (key) => {
    let educations = [
      { key: 1, value: "بی سواد" },
      { key: 2, value: "ابتدایی" },
      { key: 3, value: "دیپلم" },
      { key: 4, value: "کاردانی" },
      { key: 5, value: "کارشناسی" },
      { key: 6, value: "کارشناسی ارشد" },
      { key: 7, value: "دکترا" },
      { key: 8, value: "پسا دکترا" },
    ];

    return educations.find((e) => e.key === key)?.value;
  };
  const exportExcel = async () => {
    await useApi.get(
      `/event/${id}/report?${
        team != null ? "team=true&eventId=" + eventId + "&" : ""
      }token=${getStoredAuthToken()}`,
      {},
      (res) => {
        navigate("/panel/excel");
        return success("گزارش با موفقیت در صف خروجی قرار گرفت");
      },
      (err) => {
        if (err.status == 429) {
          return error(
            "در حال حاضر صف گزارش پر است لطفا تا اتمام عملیات های گذشته منتظر بمانید و مجددا اقدام نمایید."
          );
        } else {
          error("هنگام ارسال برای صف خروجی مشکلی رخ داده است");
        }
      }
    );
  };

  const searchByIssueTracking = () => {
    if (issueTracking.length === 0) {
      error("لطفا کد پیگیری را وارد نمایید.");
      return;
    }
    return navigate(
      `/panel/event/register/${id}?issue_tracking=${issueTracking}`
    );
  };
  const USER_DOCUMENT_FIELDS = [
    { key: "avatar", label: "تصویر پرسنلی" },
    { key: "national_card_picture", label: "کارت ملی" },
    { key: "birth_certificate_picture", label: "شناسنامه" },
    { key: "insurance_picture", label: "بیمه ورزشی" },
    { key: "picture_cover_letter", label: "معرفی‌نامه" },
    { key: "picture_commitment_letter", label: "تعهدنامه" },
    { key: "organization_letter", label: "نامه سازمان" },
    { key: "recruitment_order", label: "حکم کارگزینی" },
    { key: "file", label: "فایل", type: "file" },
  ];

  const getUserDocuments = (user) =>
    USER_DOCUMENT_FIELDS.map(({ key, label, type = "image" }) => {
      const raw = user?.[key];
      if (!raw || (type !== "file" && !isStoredMediaPath(raw))) {
        return null;
      }
      const src = resolveMediaUrl(raw);
      if (!src) return null;
      return { label, src, type, raw };
    }).filter(Boolean);

  const openImage = (src) => {
    if (!src) return;
    setImageViewSrc(src);
    setImageViewModalOpen(true);
  };

  const openDocumentsModal = (user) => {
    setDocumentsModalUser(user);
    setDocumentsModalOpen(true);
  };

  const closeDocumentsModal = () => {
    setDocumentsModalOpen(false);
    setDocumentsModalUser(null);
  };
  const getIDCard = async (nat_code) => {
    setIdCardLoading(true);
    let teamIdProp = team && id ? `?team_id=${id}` : "";
    let event = teamIdProp ? eventId : id;
    await useApi.get(
      `/id-card/${event}/user/${nat_code}${teamIdProp}`,
      {},
      (res) => {
        let data = res.data.data;
        if (data?.success == false) {
          setIdCardLoading(false);
          return error(data?.message);
        }
        setIdCardLoading(false);
        return navigate(`/id-card/show`, {
          state: {
            data: res.data.data,
            multi: false,
          },
        });
      },
      (err) => {
        setIdCardLoading(false);
        error("هنگام دریافت اطلاعات خطایی رخ داده است.");
      }
    );
  };
  const getIDCards = async (users) => {
    setIdCardLoading(true);
    let teamIdProp = team && id ? `?team_id=${id}` : "";
    let event = teamIdProp ? eventId : id;
    await useApi.post(
      `/id-card/${event}/users${teamIdProp}`,
      { users },
      (res) => {
        let data = res.data.data;
        if (data?.success == false) {
          setIdCardLoading(false);
          return error(data?.message);
        }
        setIdCardLoading(false);
        return navigate(`/id-card/show`, {
          state: {
            data: res.data.data,
            multi: true,
          },
        });
      },
      (err) => {
        setIdCardLoading(false);
        error("هنگام دریافت اطلاعات خطایی رخ داده است.");
      }
    );
  };
  const acceptInfo = async (userId) => {
    setAcceptLoading(true);
    await useApi.post(
      `/user/${userId}/accept-info`,
      {},
      async (res) => {
        await getUsers();
        success("درخواست با موفقیت انجام شد.");
        setAcceptLoading(false);
      },
      (err) => {
        setAcceptLoading(false);
        error("هنگام ارسال درخوسات خطایی رخ داده است.");
      }
    );
  };

  const registerFilter = (values, setSubmiting) => {
    let regexPaginate = new RegExp(/page=([0-9]+)/);
    let pageExists = regexPaginate.test(search);
    let paginate = parseParams?.page;

    let filter = pageExists ? `?page=${paginate}` : "";
    Object.entries(values).forEach((item) => {
      if (item[1] != 0 || item[1]?.length > 0) {
        filter +=
          filter.length > 0
            ? `&${item[0]}=${item[1]}`
            : `?${item[0]}=${item[1]}`;
      }
    });
    let teamIdProp = team && id ? `?team_id=${id}` : "";
    let event = teamIdProp ? eventId : id;
    navigate(`/panel/event/register/${event}${filter}`);

    setFilterModal(false);
  };
  const removeFilters = () => {
    let teamIdProp = team && id ? `?team_id=${id}` : "";
    let event = teamIdProp ? eventId : id;
    navigate(`/panel/event/register/${event}`);
    setFilterModal(false);
  };

  const toggleSelectOne = useCallback(
    (userId) => {
      setSelected((prev) => {
        if (prev.includes(userId)) {
          return prev.filter((i) => i !== userId);
        }
        return [...prev, userId];
      });
    },
    [setSelected]
  );

  const toggleSelectAll = useCallback(() => {
    const visible = eventContext.users?.data ?? [];
    const visibleIds = visible.map((u) => u.id);
    const allSelectedOnPage = visibleIds.every((id) => selected.includes(id));
    if (allSelectedOnPage) {
      setSelected((prev) => prev.filter((id) => !visibleIds.includes(id)));
    } else {
      setSelected((prev) => Array.from(new Set([...prev, ...visibleIds])));
    }
  }, [eventContext.users, selected]);

  const processSelected = async (ids) => {
    if (!ids || ids.length === 0) {
      return error("هیچ آیتمی انتخاب نشده است.");
    }
    const selectedUsers = eventContext.users?.data?.filter((u) =>
      ids.includes(u.id)
    );
    const notAccepted = selectedUsers?.filter((u) => u?.accept_info != 1);
    if (notAccepted?.length > 0) {
      return error(
        "در بین ورزشکاران انتخاب شده برخی ها هنوز تایید نشدند لطفا مجددا بررسی و سپس اقدام کنید."
      );
    }
    const acceptedUsers = selectedUsers?.filter((u) => u?.accept_info == 1);
    await getIDCards(acceptedUsers?.map((u) => u?.nat_code));
    // setBulkLoading(true);
    // const payload = {
    //   ids,
    // };
    // await useApi.post(
    //   `/event/${id}/users/bulk-action`,
    //   payload,
    //   async (res) => {
    //     setBulkLoading(false);
    //     success("عملیات با موفقیت انجام شد.");
    //     await getUsers();
    //     setSelected([]);
    //   },
    //   (err) => {
    //     setBulkLoading(false);
    //     error("خطا در انجام عملیات.");
    //   }
    // );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className="d-flex flex-row justify-content-between border-bottom pb-2 my-3">
        <div className="d-flex flex-row mt-2">
          <i className="fad fa-list f-20 text-secondary mx-2"></i>
          <h1 className="text-secondary f-13 font-weight-bold mt-1 mb-0 p-0">
            لیست کاربران ثبت نام شده
          </h1>
        </div>
        <span className="f-16 text-secondary">
          تعداد ثبت نامی‌: {eventContext.users?.meta?.pagination?.total ?? 0}{" "}
          نفر
        </span>
        <div className="d-flex flex-row align-items-center">
          <button
            onClick={() => setFilterModal(true)}
            className="d-flex flex-row btn btn-outline-info mx-2"
          >
            <i className="fad fa-filter f-16 mx-2"></i>
            <span className="f-13">فیلتر</span>
          </button>
          {can("Super Admin") || can("Dyaco Admin") ? (
            <button
              onClick={exportExcel}
              className="d-flex flex-row btn btn-outline-info "
            >
              <i className="fas fa-file-excel f-16 mx-2"></i>
              <span className="f-13">گزارش اکسل </span>
            </button>
          ) : null}
        </div>
      </div>

      <div className="d-flex align-items-center justify-content-between my-2">
        <div>
          <strong>{selected.length}</strong> <span>آیتم انتخاب شده</span>
        </div>

        <div className="d-flex">
          <button
            className="btn btn-sm btn-primary mx-1"
            disabled={selected.length === 0 || bulkLoading}
            onClick={() => processSelected(selected)}
          >
            {bulkLoading ? "در حال انجام..." : "دریافت ای دی کارت"}
          </button>
        </div>
      </div>

      <div className="w-100 overflow-auto">
        {eventContext.users?.data?.length > 0 ? (
          <table className="table table-hover">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    ref={selectAllRef}
                    onChange={toggleSelectAll}
                  />
                </th>
                <th>#</th>
                <th>صدور آی دی کارت</th>
                <th>سمت</th>
                <th>نام و نام خانوادگی</th>
                <th>کد ملی</th>
                <th>وضعیت پرداختی</th>
                <th>شماره همراه</th>
                <th>تاریخ تولد</th>
                <th>جنسیت</th>
                <th>استان</th>
                <th>شهرستان</th>
                <th>مدارک</th>
                <th>تایید/رد</th>
              </tr>
            </thead>
            <tbody>
              {eventContext.users?.data?.map((item, index) => {
                const userDocs = getUserDocuments(item);
                return (
                <tr key={item.id}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selected.includes(item.id)}
                      onChange={() => toggleSelectOne(item.id)}
                    />
                  </td>
                  <td>
                    {countOfRecourd(
                      index,
                      eventContext.users?.meta?.pagination?.per_page,
                      eventContext.users?.meta?.pagination?.current_page
                    )}
                  </td>
                  <td>
                    <button
                      className="btn btn-info f-11"
                      onClick={() => getIDCard(item?.nat_code)}
                    >
                      {idCardLoading ? (
                        <div
                          className="spinner-border spinner-border-sm text-white mb-1 mx-2"
                          role="status"
                        ></div>
                      ) : (
                        <i className="fad fa-eye text-dark-mode f-15"></i>
                      )}
                    </button>
                  </td>
                  <td>{formatSidLabel(item)}</td>
                  <td>
                    {item?.first_name} {item?.last_name}
                  </td>
                  <td>{item?.nat_code ?? "-"}</td>
                  <td>
                    {item?.event_free == 1 ? (
                      "پرداختی ثبت نشده است"
                    ) : item?.transaction?.filter((t) => t.event?.id == eventId)
                        ?.length == 0 ? (
                      "پرداختی ثبت نشده است"
                    ) : item?.transaction?.filter(
                        (t) => t.event?.id == eventId && t.status == 1
                      )[0] ? (
                      <span className="badge badge-success badge-pill p-2">
                        پرداخت شده
                      </span>
                    ) : (
                      <span className="badge badge-danger badge-pill p-2">
                        پرداخت نشده
                      </span>
                    )}
                  </td>
                  <td>{item?.mobile ?? "-"}</td>
                  <td>{item?.birth_date ?? "-"}</td>
                  <td>{item?.gender === 1 ? "مرد" : "زن"}</td>
                  <td>{item?.province_name ?? "-"}</td>
                  <td>{item?.city ?? "-"}</td>
                  <td>
                    {userDocs.length > 0 ? (
                      <button
                        type="button"
                        className="btn btn-outline-info btn-sm f-11"
                        onClick={() => openDocumentsModal(item)}
                      >
                        <i className="fad fa-images mx-1"></i>
                        مشاهده ({userDocs.length})
                      </button>
                    ) : (
                      <span className="text-muted f-11">—</span>
                    )}
                  </td>
                  <td>
                    {item?.accept_info == 1 ? (
                      <button
                        className="d-flex flex-row btn btn-success f-11"
                        onClick={() => acceptInfo(item?.id)}
                      >
                        {acceptLoading ? (
                          <div
                            className="spinner-border spinner-border-sm text-white"
                            role="status"
                          ></div>
                        ) : (
                          <>
                            <i className="fad fa-check text-dark-mode f-15 mx-1"></i>
                            تایید
                          </>
                        )}
                      </button>
                    ) : (
                      <button
                        className="d-flex flex-row btn btn-danger f-11"
                        onClick={() => acceptInfo(item?.id)}
                      >
                        {acceptLoading ? (
                          <div
                            className="spinner-border spinner-border-sm text-white"
                            role="status"
                          ></div>
                        ) : (
                          <>
                            <i className="far fa-times text-dark-mode f-15 mx-1"></i>
                            رد
                          </>
                        )}
                      </button>
                    )}
                  </td>
                </tr>
              );
              })}
            </tbody>
          </table>
        ) : (
          <div className="d-flex flex-row justify-content-center border p-3 my-3	">
            <span className="f-13 font-weight-bold text-secondary">
              کاربری ثبت نام نکرده است
            </span>
          </div>
        )}
      </div>
      {(Number(eventContext.users?.meta?.pagination?.total_pages) || 0) > 0 ? (
        <Pagination
          totalPage={eventContext.users?.meta?.pagination?.total_pages}
          basePath={`/panel/event/register/${id}`}
          search={search}
        />
      ) : null}
      <ModalCustom modalIsOpen={modalIsOpen}>
        <div className="d-flex flex-row border-bottom pb-2">
          <i className="fad fa-warning f-20 mx-2"></i>
          <span className="">آیا از حذف فرم مطمئنید‌؟</span>
        </div>
        <div className="d-flex flex-row justify-content-around my-3">
          <button
            onClick={() => setModalIsOpen(false)}
            className="btn btn-danger w-48 f-13"
          >
            لغو
          </button>
          <button
            onClick={() => removeForm(formRemoveId)}
            className="btn btn-success w-48 f-13"
          >
            {removeLoading ? (
              <div
                className="spinner-border spinner-border-sm text-white mb-1"
                role="status"
              ></div>
            ) : (
              "بله"
            )}
          </button>
        </div>
      </ModalCustom>

      <ModalCustom
        modalIsOpen={documentsModalOpen}
        styles={{
          content: {
            width: "min(920px, 92vw)",
            maxHeight: "90vh",
            overflow: "hidden",
          },
        }}
      >
        <div className="d-flex flex-row justify-content-between align-items-center border-bottom pb-2">
          <span className="font-weight-bold">
            مدارک{" "}
            {documentsModalUser
              ? `${documentsModalUser.first_name ?? ""} ${documentsModalUser.last_name ?? ""}`.trim()
              : ""}
          </span>
          <i
            className="far fa-times f-20 c-pointer"
            onClick={closeDocumentsModal}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && closeDocumentsModal()}
          ></i>
        </div>
        <div className="my-3" style={{ maxHeight: "70vh", overflowY: "auto" }}>
          {documentsModalUser &&
          getUserDocuments(documentsModalUser).length > 0 ? (
            <div className="row">
              {getUserDocuments(documentsModalUser).map((doc) => (
                <div key={doc.label} className="col-6 col-md-4 mb-3">
                  <div className="bg-white rounded p-2 text-dark">
                    <div className="f-12 font-weight-bold mb-2">{doc.label}</div>
                    {doc.type === "file" ? (
                      <a
                        href={doc.src}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-sm btn-outline-primary w-100"
                      >
                        دانلود فایل
                      </a>
                    ) : (
                      <>
                        <img
                          src={doc.src}
                          alt={doc.label}
                          className="img-thumbnail w-100 c-pointer d-block mx-auto"
                          style={{
                            maxHeight: 160,
                            minHeight: 80,
                            objectFit: "contain",
                            backgroundColor: "#f8f9fa",
                          }}
                          onClick={() => openImage(doc.src)}
                        />
                        <a
                          href={doc.src}
                          target="_blank"
                          rel="noreferrer"
                          className="f-11 d-block text-center mt-2 text-primary"
                        >
                          باز کردن در تب جدید
                        </a>
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-muted text-center mb-0 f-13">
              مدرکی برای این کاربر ثبت نشده است.
            </p>
          )}
        </div>
        {documentsModalUser ? (
          <div className="d-flex flex-row justify-content-between border-top pt-3">
            <button
              type="button"
              onClick={closeDocumentsModal}
              className="btn btn-secondary f-13"
            >
              بستن
            </button>
            <div className="d-flex">
              {documentsModalUser.accept_info == 1 ? (
                <button
                  type="button"
                  className="btn btn-outline-success f-13 mx-1"
                  disabled={acceptLoading}
                  onClick={() => {
                    acceptInfo(documentsModalUser.id);
                    closeDocumentsModal();
                  }}
                >
                  {acceptLoading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                    ></span>
                  ) : (
                    <>
                      <i className="fad fa-check mx-1"></i>
                      تایید شده — تغییر
                    </>
                  )}
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-success f-13 mx-1"
                  disabled={acceptLoading}
                  onClick={() => {
                    acceptInfo(documentsModalUser.id);
                    closeDocumentsModal();
                  }}
                >
                  {acceptLoading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                    ></span>
                  ) : (
                    <>
                      <i className="fad fa-check mx-1"></i>
                      تایید
                    </>
                  )}
                </button>
              )}
              <button
                type="button"
                className="btn btn-danger f-13"
                disabled={acceptLoading}
                onClick={() => {
                  acceptInfo(documentsModalUser.id);
                  closeDocumentsModal();
                }}
              >
                {acceptLoading ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                  ></span>
                ) : (
                  <>
                    <i className="far fa-times mx-1"></i>
                    رد
                  </>
                )}
              </button>
            </div>
          </div>
        ) : null}
      </ModalCustom>

      <ModalCustom
        modalIsOpen={imageViewModalOpen}
        styles={{
          content: {
            zIndex: 10000000000000000000002,
            width: "min(720px, 90vw)",
          },
        }}
      >
        <div className="d-flex flex-row border-bottom pb-2">
          <i className="fad fa-images f-20 mx-2"></i>
          <span className="">مشاهده و دانلود تصویر</span>
        </div>
        <div className="d-flex flex-column justify-content-center align-items-center my-3 bg-white rounded p-2">
          <img
            src={imageViewSrc}
            alt="donload"
            className="img-thumbnail"
            style={{ maxHeight: "70vh", maxWidth: "100%", objectFit: "contain" }}
          />
        </div>
        <div className="d-flex flex-row justify-content-around my-3">
          <button
            onClick={() => setImageViewModalOpen(false)}
            className="btn btn-danger w-48 f-13"
          >
            بستن
          </button>
          <a
            download={true}
            href={imageViewSrc}
            target="_blank"
            className="btn btn-success w-48 f-13"
          >
            دانلود
          </a>
        </div>
      </ModalCustom>

      <ModalCustom modalIsOpen={filterModal}>
        <div className="d-flex flex-row justify-content-between align-items-center border-bottom pb-2">
          <span className="">فیلتر تراکنش ها</span>
          <i
            className="far fa-times text-white f-20 mx-2 c-pointer"
            onClick={() => setFilterModal(false)}
          ></i>
        </div>
        <div className="w-100 my-3 owerflow-auto">
          <Formik
            initialValues={{
              issue_tracking: parseParams?.issue_tracking ?? "",
              nat_code: parseParams?.nat_code ?? "",
              first_name: parseParams?.first_name ?? "",
              last_name: parseParams?.last_name ?? "",
            }}
            onSubmit={registerFilter}
            validationSchema={validationSchema}
          >
            {({
              handleSubmit,
              handleChange,
              values,
              errors,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <label className="text-white f-13">نام</label>
                      <input
                        type="text"
                        className="form-control w-100"
                        onChange={handleChange}
                        value={values.first_name}
                        name="first_name"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <label className="text-white f-13">نام خانوادگی</label>
                      <input
                        type="text"
                        className="form-control w-100"
                        onChange={handleChange}
                        value={values.last_name}
                        name="last_name"
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <label className="text-white f-13">کد ملی</label>
                      <input
                        type="text"
                        className="form-control w-100"
                        onChange={handleChange}
                        value={values.nat_code}
                        name="nat_code"
                      />
                    </div>
                  </div>
                  {!team && (
                    <div className="col-12 col-md-6">
                      <div className="form-group">
                        <label className="text-white f-13">کد پیگیری</label>
                        <input
                          type="text"
                          className="form-control w-100"
                          onChange={handleChange}
                          value={values.issue_tracking}
                          name="issue_tracking"
                        />
                      </div>
                    </div>
                  )}

                  <div className="col-12 d-flex flex-row justify-content-center align-items-center">
                    <span
                      className="btn px-5 btn-danger text-white f-12 my-3 c-pointer"
                      onClick={() => setFilterModal(false)}
                    >
                      انصراف
                    </span>
                    <button
                      type="button"
                      onClick={removeFilters}
                      className="btn px-5 btn-secondary text-white f-12 my-3 mx-2"
                    >
                      حذف فیلتر ها
                    </button>
                    <button className="btn px-5 btn-info text-white f-12 my-3">
                      فیلتر
                    </button>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </ModalCustom>
    </Master>
  );
};

export default EventRegister;
